import PropTypes from 'prop-types';
import React from 'react';
import { compose, branch, renderNothing, withPropsOnChange } from 'recompose';
import { get } from 'lodash';

import leftImage from 'assets/images/search/pagination-arrow-left.svg';
import rightImage from 'assets/images/search/pagination-arrow-right.svg';

import { Image } from 'components/core/Image';

import { PaginationItem } from 'components/core/Pagination';
import './pagination.scss';

export const enhance = compose(
	branch((props) => !props.pages || !props.pages.length, renderNothing),
	withPropsOnChange(
		['selectedPage', 'pages'],
		({ selectedPage, pages, pageLimit = 5 }) => {
			const totalPagesLength = pages.length;
			const pageIndex = selectedPage - 1;

			const startPage = Math.max(
				1,
				selectedPage - Math.floor(pageLimit / 2)
			);

			const endPage = Math.min(
				startPage + pageLimit - 1,
				totalPagesLength
			);

			const notAtStartOfPages = startPage !== 1;
			const notAtEndOfPages = endPage !== totalPagesLength;

			const pagesToShow = [];

			for (let i = startPage; i <= endPage; i += 1) {
				pagesToShow.push(i);
			}

			if (notAtStartOfPages) {
				pagesToShow.unshift(1);
			}

			if (endPage !== totalPagesLength) {
				pagesToShow.push(totalPagesLength);
			}

			return {
				prevPage: get(pages, pageIndex - 1, {}),
				nextPage: get(pages, pageIndex + 1, {}),
				notAtStartOfPages,
				notAtEndOfPages,
				pagesToShow
			};
		}
	)
);

export function NewPagination({
	pages,
	selectedPage,
	prevPage,
	nextPage,
	onPageChange,
	notAtStartOfPages,
	notAtEndOfPages,
	pagesToShow
}) {
	return (
		<ul className="pagination">
			<PaginationItem
				page={prevPage}
				disabled={selectedPage <= 1}
				onPageChange={onPageChange}
			>
				<Image src={leftImage} alt={"leftArrow"}/>
			</PaginationItem>

			{/* Pagination Items */}
			{pagesToShow &&
				pagesToShow.map((page, index) => {
					const canShowStartExpander =
						index === 1 && notAtStartOfPages;
					const canShowEndExpander =
						index === pagesToShow.length - 2 && notAtEndOfPages;

					let paginationItemContent;

					if (canShowStartExpander || canShowEndExpander) {
						paginationItemContent = '...';
					} else {
						paginationItemContent = page;
					}

					return (
						<PaginationItem
							key={page}
							page={pages[page - 1]} // Adjust index
							selected={page === selectedPage}
							onPageChange={onPageChange}
						>
							{paginationItemContent}
						</PaginationItem>
					);
				})}

			<PaginationItem
				page={nextPage}
				disabled={selectedPage >= pages.length}
				onPageChange={onPageChange}
			>
				<Image src={rightImage} alt={"rightArrow"} />
			</PaginationItem>
		</ul>
	);
}

NewPagination.propTypes = {
	pages: PropTypes.arrayOf(
		PropTypes.shape({
			link: PropTypes.string
		})
	).isRequired,
	selectedPage: PropTypes.number,
	onPageChange: PropTypes.func,
	prevPage: PropTypes.object,
	nextPage: PropTypes.object,
	notAtStartOfPages: PropTypes.bool,
	notAtEndOfPages: PropTypes.bool,
	pagesToShow: PropTypes.arrayOf(PropTypes.number)
};

export default enhance(NewPagination);
